const VERIFALIA_URL = '/action/ajax/verifalia-validate-email?email=';

export const VERIFALIA_SELECTORS = {
  verifaliaElementsSelector: `.js-verifalia-validation [data-verifalia-id="emailId"]`
};

export const VERIFALIA_CLASSES = {
  errorClass: "error",
  warningClass: "warning",
  successClass: "success"
};

export const validateEmail = function (email) {
  if (email) {
    let url = VERIFALIA_URL + email;
    return performGet(url).responseJSON;
  }
}

const performGet =  function (url) {
  if (url) {
    var ajaxConf = {
        url: url,
        async: false
    };
    return $.get(ajaxConf);
  }
}

//metodo non utilizzato nell'implementazione corrente, le classi di warnign ed errore sono gestite dal compomente FormValidatorComponent.js
/*const verifaliaCallback = (res) => {
  const {verifaliaElementsSelector} = VERIFALIA_SELECTORS;
  const {errorClass, warningClass,successClass} = VERIFALIA_CLASSES;

  if (res) {
    const $inputElement = $(verifaliaElementsSelector);
    const $parentForm = $inputElement.closest('.form-group');
    const inputName = $inputElement.attr('name') || ""
    const $errorMsg = $(`[id='${inputName}.error']`, $parentForm);
    const $warningMsg = $(`[id='${inputName}.warning']`, $parentForm);

    const isValid = res.emailValid === true;
    const hasWarning = res.emailWarning === true;

    $inputElement.removeClass(errorClass);
    $errorMsg.addClass('d-none');
    $warningMsg.addClass('d-none');

    if (!isValid) {
      // email non valida
      $errorMsg.removeClass('d-none');
      $inputElement.addClass(errorClass);
      $inputElement.removeClass(successClass);
    } else if (hasWarning) {
      // email warning
      $warningMsg.removeClass('d-none');
      $inputElement.removeClass(errorClass);
      $inputElement.addClass(warningClass);
      $inputElement.removeClass(successClass);
    }
  }
}*/
